<template>
    <div>
        <card :title="requestsTitle" createUrlButton="/solicitudes/crear" icon="list-alt">
            <search-request-form :applicants="applicants" :disable="false" :filter="filter" :targets="targets"
                @exportPdf="exportPdf" @exportXls="exportXls" @index="index"></search-request-form>
            <span>
                <div v-if="requests.length > 0" class="table-responsive mt-4">
                    <manage-table :withStartSticky="true" :withEndSticky="true" :hasOptions="true"
                        :headers="headersToRole" :hover="true">
                        <tr v-for="r in requests" :key="r.id" v-bind:class="{
                            'bg-light-danger':
                                r.allRejected ||
                                r.allInvalid ||
                                r.allCancelled ||
                                r.allRejectedQuality,
                        }">
                            <td>
                                <router-link :to="`/solicitudes/visualizar/${r.id}`" class="btn btn-info btn-sm ml-2">
                                    {{ r.id }}
                                </router-link>
                            </td>
                            <td>
                                <span :class="r.dispatchEnterpriseName == 'No Establecido' ? 'badge badge-warning' : ''">{{
                                    r.dispatchEnterpriseName }}</span>

                            </td>
                            <td>{{ r.sampleTarget.name }}</td>
                            <td v-if="isAdmin || isMainCommercial || isDispatcher || isOenology || isQuality">
                                {{ r.authorData.fullName }}
                            </td>
                            <td v-if="isAdmin || isMainCommercial || isOenology || isDispatcher || isQuality">
                                <span class="badge badge-info">{{ r.authorData.email }}</span>
                            </td>
                            <td>{{ r.sendedAtString }}</td>
                            <td>
                                <span v-if="r.dispatchManagementDeadlineString">{{ r.dispatchManagementDeadlineString }}</span>
                                <span v-else-if="r.sampleState !== 0" class="text-muted"
                                    title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">
                                    Pendiente de envío
                                </span>
                                <span v-else class="text-muted">Sin Registro</span>
                            </td>
                            <td>{{ r.requiredDispatchDateString }}</td>
                            <td v-if="!r.allRejected && !r.allInvalid && !r.allCancelled">
                                <span :class="r.statusColor">
                                    {{ r.status }}
                                </span>
                                <div v-if="r.subStates.length > 0"
                                    style="border: 2px solid #85cfe4 !important; border-radius: 10px; padding: 4px; margin-top: 2px; background-color: white;">
                                    <span v-for="subState in r.subStates" :key="subState.name"
                                        v-bind:class="subState.classes">
                                        {{ subState.name }}
                                    </span>
                                </div>
                            </td>
                            <td v-if="r.allRejected || r.allInvalid || r.allCancelled">
                                <span v-if="r.allRejected" class="badge badge-pill badge-danger">Despacho
                                    Rechazado</span>
                                <span v-if="r.allInvalid" class="badge badge-pill badge-danger">Invalidado desde
                                    Enología</span>
                                <span :title="r.cancelledReason" v-if="r.allCancelled || r.cancelledAt"
                                    class="badge badge-pill badge-danger">Cancelado por
                                    Solicitante</span>
                            </td>
                            <td style="min-width: 300px">
                                <b-progress v-if="!r.allRejected &&
                                    !r.allInvalid &&
                                    !r.allCancelled &&
                                    !r.allRejectedQuality
                                " :max="max" height="2rem">
                                    <b-progress-bar :value="r.totalPercent" variant="success">
                                        <strong>{{ r.totalPercent }}% / {{ max }}%</strong>
                                    </b-progress-bar>
                                </b-progress>
                            </td>
                            <td v-if="r.progressDispatch == true">
                                <span class="badge badge-pill badge-secondary badgeBoolean">Si</span>
                            </td>
                            <td v-if="r.progressDispatch == false">
                                <span class="badge badge-pill badge-dark badgeBoolean">No</span>
                            </td>
                            <td v-if="r.dispatchPercent == 100 && isDispatcher" style="max-width: 200px">
                                <b-progress :max="max" height="2rem">
                                    <b-progress-bar :value="r.dispatchPorcent" variant="success">
                                        <strong>{{ r.dispatchPorcent }}% / {{ max }}%</strong>
                                    </b-progress-bar>
                                </b-progress>
                            </td>
                            <td v-else-if="r.dispatchPercent < 100 &&
                                (isDispatcher || isCommercialDispatcher)
                            ">
                                <b-progress :max="max" height="2rem">
                                    <b-progress-bar :value="r.dispatchPercent" variant="primary">
                                        <strong>{{ r.dispatchPercent }}% / {{ max }}%</strong>
                                    </b-progress-bar>
                                </b-progress>
                            </td>
                            <td style="min-width: 240px;">
                                <router-link
                                    v-if="(r.status == 'Creado' || r.requiredRevisionCommercial) && (isCommercial ||
                                        isAdmin ||
                                        isMainCommercial ||
                                        isCommercialDispatcher ||
                                        (isOenology && r.authorData && r.authorData.id === $store.getters.user.id)) && !r.allCancelled"
                                    :to="'/solicitudes/ver/' + r.id" class="btn btn-primary btn-sm ml-2"
                                    style="width: 34px; height: 31px" title="Editar Solicitud">
                                    <i class="fas fa-edit"></i>
                                </router-link>
                                <router-link v-if="(r.requiredRevisionComponents || r.requiredRevisionOenologyAndComponents) &&
                                    (isDispatcher ||
                                        isAdmin ||
                                        isMainCommercial ||
                                        isCommercialDispatcher)
                                " :to="'/solicitudes/despacho/bodega/' + r.id" class="btn btn-warning btn-sm ml-2"
                                    style="width: 34px; height: 31px" title="Revisar Componentes de la solicitud">
                                    <i class="fas fa-tasks"></i>
                                </router-link>
                                <router-link v-if="r.requiredDispatch &&
                                    (isDispatcher ||
                                        isAdmin ||
                                        isMainCommercial ||
                                        isCommercialDispatcher)
                                " :to="'/solicitudes/validar/despacho/' + r.id" class="btn btn-warning btn-sm ml-2"
                                    style="width: 34px; height: 31px" title="Despachar Solicitudes Desde Bodega">
                                    <i class="fas fa-truck"></i>
                                </router-link>
                                <router-link v-if="r.requiredRevisionQuality && (isAdmin || isQuality)"
                                    :to="`/solicitudes/calidad/${r.id}`" class="btn btn-warning btn-sm ml-2"
                                    style="width: 34px; height: 31px" title="Verificar calidad">
                                    <i class="fas fa-calendar-check"></i>
                                </router-link>
                                <router-link v-if="r.requiredDelivered &&
                                    (isCourier || isAdmin || isMainCommercial)
                                " :to="'/solicitudes/despacho/' + r.id" class="btn btn-warning btn-sm ml-2"
                                    style="width: 34px; height: 31px" title="Despachar Solicitudes Desde Courier">
                                    <i class="fas fa-plane-departure"></i>
                                </router-link>
                                <router-link v-if="(r.requiredRevisionOenology || r.requiredRevisionOenologyAndComponents) &&
                                    (isCourier || isAdmin || isMainCommercial || isOenology)
                                " :to="'/solicitudes/validar/' + r.id" class="btn btn-warning btn-sm ml-2"
                                    style="width: 34px; height: 31px" title="Validación de Enología">
                                    <i class="fas fa-flask"></i>
                                </router-link>
                                <button v-if="r.status == 'Creado' &&
                                    !r.allCancelled &&
                                    (isCommercial || isAdmin || isMainCommercial)
                                " class="btn btn-danger btn-sm ml-2" style="width: 34px; height: 31px"
                                    title="Eliminar Solicitud" @click="deleteRequest(r.id)">
                                    <i class="fas fa-trash"></i>
                                </button>
                                <button v-if="isAdmin ||
                                    isCommercial ||
                                    isMainCommercial ||
                                    isCommercialDispatcher ||
                                    isOenology
                                " class="btn btn-sm btn-dark ml-2" style="width: 34px; height: 31px"
                                    title="Clonar Solicitud" type="button" @click="showCloneModal(r.id)">
                                    <i aria-hidden="true" class="fas fa-clone" style="font-size: 14px"></i>
                                </button>
                                <button v-if="r.status != 'Creado' || r.allCancelled"
                                    class="btn btn-sm btn-success ml-2" style="width: 34px; height: 31px"
                                    title="Exportar XLSX" type="button" @click="exportRequest(r.id)">
                                    <i aria-hidden="true" class="fas fa-file-excel" style="font-size: 14px"></i>
                                </button>
                                <button v-if="r.status == 'Enviado' &&
                                    !r.allCancelled &&
                                    (isCommercial || isAdmin || isMainCommercial)
                                " class="btn btn-danger btn-sm ml-2" style="width: 34px; height: 31px"
                                    title="Cancelar Solicitud" @click="cancelRequest(r.id)">
                                    <i class="fas fa-ban"></i>
                                </button>
                                <button class="btn btn-sm btn-secondary ml-2" type="button"
                                    @click.prevent="showHistory(r)">
                                    <i aria-hidden="true" class="fas fa-clock"></i>
                                </button>
                            </td>
                        </tr>
                    </manage-table>
                </div>
                <alert v-else class="mt-4" message="No se han encontrado Solicitudes" />
            </span>

            <paginator :links="links" class="mt-4"></paginator>
            <modal id="clonRequestModal" :title="cloneOptions.requestCloneId != null
                ? 'Clonar FCOM N° ' + cloneOptions.requestCloneId
                : ''
                " @modalClose="index">
                <clone-request-form :cloneOptions="cloneOptions" :newHeader="newHeader"
                    @saveCloneRequest="saveCloneRequest"></clone-request-form>
            </modal>
            <modal id="showHistory" :lg="true" title="Historial de solicitud">
                <history-modal-request :historyOptions="historyOptions"></history-modal-request>
            </modal>
        </card>
    </div>
</template>

<script>
// @ is an alias to /src
import { Delete, Get, Post, Put } from "../helper/axios.js";
import Card from "@/components/Card.vue";
import { getUrlQuery } from "../helper/queryHelper";
import $ from "jquery";
import HistoryModalRequest from "@/views/requests/history/HistoryModalRequest.vue";
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
    name: "Home",
    data() {
        return {
            cloneOptions: {
                requestCloneId: null,
                header: false,
                dispatch: false,
                newProduct: false,
                pt: false,
                gb: false,
                newHeader: {},
            },
            historyOptions: {
                id: null,
                history: [],
            },
            newHeader: {
                businessUnit: null,
                costCenter: null,
                requiredDispatchDate: null,
                progressDispatch: false,
                sampleTarget: null,
            },
            Put,
            isAdmin: this.$store.getters.isAdmin,
            isDispatcher: this.$store.getters.isDispatcher,
            isCommercial: this.$store.getters.isCommercial,
            isCourier: this.$store.getters.isCourier,
            isMainCommercial: this.$store.getters.isMainCommercial,
            isCommercialDispatcher: this.$store.getters.isCommercialDispatcher,
            isOenology: this.$store.getters.isOenology,
            isQuality: this.$store.getters.isQuality,
            Delete,
            Post,
            requests: [],
            apiUrl: this.$store.getters.apiUrl,
            Get,
            max: 100,
            requestsTitle: "",
            getUrlQuery,
            search: {},
            filter: {
                number: "",
                to: "",
                from: "",
                state: "",
            },
            modalTitle: "",
            components: [],
            links: {},
            headersToRole: [],
            applicants: [],
            targets: [],
            history: [],
        };
    },
    watch: {
        urlQuery: function () {
            this.index();
        },
    },
    created() {
        this.index();
        this.getApplicants();
        this.getTargets();
    },
    methods: {
        index() {
            if (this.isAdmin || this.isMainCommercial || this.isOenology || this.isQuality) {
                this.requestsTitle = "Todas las Solicitudes";
                this.headersToRole = [
                    "N° de Solicitud",
                    "Empresa/Cliente",
                    "Objetivo",
                    "Nombre Solicitante",
                    "Correo solicitante",
                    "Fecha de Envío",
                    "Fecha límite de gestión",
                    "Fecha requerida de Despacho",
                    "Estado",
                    "Progreso total",
                    "Despacho Progresivo",
                ];
            } else if (this.isCommercialDispatcher) {
                this.requestsTitle = "Mis Solicitudes y por Despachar";
                this.headersToRole = [
                    "N° de Solicitud",
                    "Empresa/Cliente",
                    "Objetivo",
                    "Fecha de Envío",
                    "Fecha límite de gestión",
                    "Fecha requerida de Despacho",
                    "Estado",
                    "Progreso total",
                    "Despacho Progresivo",
                    "Progreso Despacho",
                ];
            } else if (this.isDispatcher) {
                this.requestsTitle = "Solicitudes por Revisar Componentes / Despachar";
                this.headersToRole = [
                    "N° de Solicitud",
                    "Empresa/Cliente",
                    "Objetivo",
                    "Nombre Solicitante",
                    "Correo Solicitante",
                    "Fecha de Envío",
                    "Fecha límite de gestión",
                    "Fecha requerida de Despacho",
                    "Estado",
                    "Progreso total",
                    "Despacho Progresivo",
                    "Progreso Despacho",
                ];
            }
            else if (this.isCourier) {
                this.requestsTitle = "Solicitudes a Despachar";
                this.headersToRole = [
                    "N° de Solicitud",
                    "Empresa/Cliente",
                    "Objetivo",
                    "Fecha de Envío",
                    "Fecha límite de gestión",
                    "Fecha requerida de Despacho",
                    "Estado",
                    "Progreso total",
                    "Despacho Progresivo",
                ];
            }
            else {
                this.requestsTitle = "Mis Solicitudes";
                this.headersToRole = [
                    "N° de Solicitud",
                    "Empresa/Cliente",
                    "Objetivo",
                    "Fecha de Envío",
                    "Fecha límite de gestión",
                    "Fecha requerida de Despacho",
                    "Estado",
                    "Progreso total",
                    "Despacho Progresivo",
                ];
            }

            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples?" + this.urlQuery, (res) => {
                this.requests = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });
        },
        getApplicants() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/applicants", (res) => {
                res.data.forEach((item) => {
                    this.applicants.push({
                        code: item.id,
                        label: item.fullName,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        getTargets() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/targets", (res) => {
                res.data.forEach((item) => {
                    this.targets.push({
                        code: item.id,
                        label: item.name,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        deleteRequest(id) {

            this.$swal({
                title: "¿Desea Eliminar la Solicitud N° " + id + "?",
                text: name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Delete(this.apiUrl + "v1/deleteRequestSamples/" + id, () => {
                        window.toastr.success(
                            "La solicitud " + id + " ha sido Cancelada correctamente."
                        );
                        this.index();
                    });
                }
            });
        },
        cancelRequest(id) {
            this.$swal({
                title: "¿Desea Cancelar la Solicitud N° " + id + "?",
                input: "text",
                text: "Si es así, debe ingresar el motivo de cancelación",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                let reason = result.value;
                let data = {
                    id: id,
                    reason: reason
                }
                this.$store.commit("setLoading", true);
                if (result.value) {
                    this.Put(this.apiUrl + "v1/requestSamples/cancel/", data, () => {
                        this.$store.commit("setLoading", false);
                        window.toastr.success(
                            "La solicitud " + id + " ha sido Cancelada correctamente."
                        );
                        this.index();
                    });
                }
            });
        },
        exportXls() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/ExportRequestSamples/export?" + this.urlQuery, (res) => {
                var array = base64ToArrayBuffer(res.data);
                var a = window.document.createElement("a");
                a.href = window.URL.createObjectURL(
                    new Blob([array], {
                        type: "application/octet-stream",
                    })
                );
                a.download = "Solicitudes de Fcom.xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.$store.commit("setLoading", false);
            });
        },
        exportPdf() {
        },
        exportRequest(id) {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/exportRequestSample/" + id, (res) => {
                var array = base64ToArrayBuffer(res.data);
                var a = window.document.createElement("a");
                a.href = window.URL.createObjectURL(
                    new Blob([array], {
                        type: "application/octet-stream",
                    })
                );
                a.download = "FCOM " + id + ".xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.$store.commit("setLoading", false);
            });
        },
        resetRequests() {
            this.requests = [];
            this.index();
        },
        showCloneModal(requestId) {
            this.cloneOptions.requestCloneId = requestId;
            $("#clonRequestModal").modal("show");
        },
        saveCloneRequest() {
            let id = this.cloneOptions.requestCloneId;
            if (this.cloneOptions.requestCloneId != null) {
                this.cloneOptions.newHeader = this.newHeader;
                this.$store.commit("setLoading", true);
                this.Post(
                    `${this.apiUrl}v1/cloneRequest/`,
                    this.cloneOptions,
                    (res) => {
                        this.cloneOptions.requestCloneId = null;
                        this.cloneOptions.header = false;
                        this.cloneOptions.dispatch = false;
                        this.cloneOptions.newProduct = false;
                        this.cloneOptions.pt = false;
                        this.cloneOptions.gb = false;
                        $("#clonRequestModal").modal("hide");
                        this.$store.commit("setLoading", false);
                        window.toastr.success(
                            "Solicitud N°" +
                            res.data +
                            " Clonada Correctamente desde FCOM N°" +
                            id
                        );
                        this.$router.push("/solicitudes/ver/" + res.data);
                    }
                );
            }
        },
        showHistory(req) {
            this.Get(`${this.apiUrl}v1/flowhistory/${req.id}`, (res) => {
                this.historyOptions.history = res.data;
                $("#showHistory").modal("show");
            });
        },
        showStatus(req) {
            if (req.status == "Calidad" && this.isDispatcher) {
                return false;
            }
            return true;
        },
    },
    components: {
        HistoryModalRequest,
        Card,
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery();
        },
    },
};
</script>
